import { Capacitor } from '@capacitor/core';

async function setupMobileChrome() {
  // Run only inside native (Capacitor) to avoid errors on web
  if (!Capacitor.isNativePlatform()) return;

  const { StatusBar, Style } = await import('@capacitor/status-bar');

  // Do not overlay, so content does not go under status bar
  await StatusBar.setOverlaysWebView({ overlay: true });
  await StatusBar.setBackgroundColor({ color: '#000000' });
  await StatusBar.setStyle({ style: Style.Dark });
}

document.addEventListener('DOMContentLoaded', setupMobileChrome);
export {};
